import React, { useState } from "react";

import { CardContent } from "./ui/card";
import { Skeleton } from "./ui/skeleton";
import { Button } from "./ui/button";
import investGraphic from "../assets/images/invest/invest_complete.svg";
import wallet from "../assets/images/settings/Wallets.png";
import { Loader2 } from "lucide-react";
import CurrencyFormatter from "../utils/currencyFormatter";
export default function WithdrawInvest({
  asset,
  pageNo,
  isQuoting,
  amount,
  loadingAmount,
  withdrawalsEnabled,
  onDepositQuote,
  setParentAmount,
}) {
  const [withdrawAmount, setWithdrawAmount] = useState(null);
  const [exceedFlag, setExceedFlag] = useState(false);
  const [minFlag, setMinFlag] = useState();
  const [hold, setHold] = useState(true);
  // const fees = parseFloat(
  //   ledgerProduct?.productId?.withdrawalFee?.feeAmount?.$numberDecimal
  // );
  const fees = 0;
  const formatter = new CurrencyFormatter();
  const handMaxAmount = () => {
    let trueMax;
    trueMax = parseFloat(amount?.availableAmount) - parseFloat(fees);
    setWithdrawAmount(trueMax);
    setParentAmount(trueMax);
    onAmountChange({ target: { value: trueMax } });
  };

  const onAmountChange = (e) => {
    const value = e.target.value;
    // const fee = parseFloat(
    //   ledgerProduct?.productId?.withdrawalFee?.feeAmount?.$numberDecimal
    // );
    const fee = 0;
    const available = parseFloat(amount?.availableAmount);
    const input = parseFloat(value);
    const inputWithFee = input + fee;

    if (!inputWithFee) {
      setHold(true);
      setMinFlag(true);
      setExceedFlag(false);
    }
    if (inputWithFee && inputWithFee <= available) {
      setHold(false);
      setMinFlag(false);
      setExceedFlag(false);
    }
    if (inputWithFee > available) {
      setHold(true);
      setMinFlag(false);
      setExceedFlag(true);
    }
    setWithdrawAmount(value);
    setParentAmount(value);
  };
  return (
    <>
      {pageNo === 0 && (
        <div className="px-20">
          {withdrawalsEnabled === true ? (
            <CardContent>
              <div className="grid grid-cols-4 gap-4 grid-rows-1 mb-3">
                <div className="space-y-2 col-span-4">
                  <label className="text-gray-600 text-sm">
                    Available balance
                  </label>
                  <div className="px-5 py-6 rounded-2xl bg-gray-50 flex-1 flex items-center">
                    {loadingAmount ? (
                      <Skeleton className="w-28 h-7 rounded-full bg-gray-300" />
                    ) : (
                      <div className="text-xl font-semibold text-gray-600">
                        {formatter.format(
                          amount?.availableAmount,
                          asset.toUpperCase()
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-800 mb-2">
                  Enter amount
                </label>
                <div
                  className={`relative flex items-center border rounded-lg px-4 py-2 bg-transparent  ${
                    minFlag || exceedFlag ? "border-2 border-rose-500 " : " "
                  }`}
                >
                  <input
                    type="text"
                    placeholder="R 0"
                    value={withdrawAmount}
                    onChange={onAmountChange}
                    className={`flex-1 py-5 outline-none bg-transparent text-base font-semibold bg-transparent outline-none 
                        focus-visible:ring-0 focus-visible:outline-none transition-colors duration-200 ease-in-out text-[24px] text-[#6D6584]
                        ${
                          minFlag || exceedFlag
                            ? "text-rose-500"
                            : "text-brand-primary"
                        }`}
                  />
                  <Button
                    onClick={handMaxAmount}
                    variant="outline"
                    className="rounded-full"
                  >
                    Max
                  </Button>
                </div>
                {minFlag && (
                  <p className="mt-1 text-sm text-rose-500">
                    Cannot withdraw R0.00
                  </p>
                )}
                {exceedFlag && (
                  <p className="mt-1 text-sm text-rose-500">
                    Amount with fee exceeds available amount: The amount with
                    the {formatter.format(fees, asset.toUpperCase())} fee
                    included exceeds the available amount of
                    {formatter.format(
                      amount?.availableAmount,
                      asset.toUpperCase()
                    )}
                  </p>
                )}
              </div>

              <div className="grid grid-cols-4 gap-4 grid-rows-1 mb-3">
                <div className="space-y-2 col-span-4">
                  <label className="text-gray-600 text-sm">Withdraw to</label>
                  <div className="px-5 py-6 rounded-2xl bg-gray-50 flex items-center">
                    <div className="mr-3">
                      <img src={wallet} alt="" />
                    </div>
                    <div className="">
                      <p className="text-[16px] text-[#423E51] font-semibold">
                        Digital Wallet
                      </p>
                      <p className="text-[14px] text-[#6D6584] font-normal">
                        0x44D...fbb3600
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-center">
                <Button
                  disabled={hold || isQuoting}
                  onClick={() => {
                    onDepositQuote?.();
                  }}
                  className="py-4 px-[170px] h-15 bg-gradient-to-tr from-purple-500 to-rose-500 text-white rounded-full font-bold mt-5"
                >
                  {isQuoting && <Loader2 className="animate-spin w-4 h-4" />}
                  Continue
                </Button>
              </div>
            </CardContent>
          ) : (
            <CardContent>
              <div className="flex flex-col items-center justify-center">
                <img src={investGraphic} alt="" className="mb-4" />
                <div className="font-bold text-xl text-center">
                  Withdrawals have been deactivated
                </div>
              </div>
            </CardContent>
          )}
        </div>
      )}
    </>
  );
}
